import { ProductLocationInventoryPricing } from "@towersystems/roam-common/lib/generated-types";
import Product from "../../../utilities/data/model/Product";
import Sale from "../../../utilities/data/model/Sale";

export const resolveSaleLocationPricing = function (
  sale: Sale,
  product: Product
): ProductLocationInventoryPricing | undefined {
  const locationPricing = product.locationInventoryPricing.find(
    (i) => i.locationId == sale.location.id
  );
  return locationPricing ?? product.locationInventoryPricing[0];
};
